import styled, { css } from 'styled-components';
export const BKJPaginationWrapper = styled.nav `
  display: flex;
  width: 260px;
  height: 44px;
  justify-content: center;
  align-items: center;
  filter: drop-shadow(0px 2px 8px rgba(13, 51, 32, 0.3));
`;
export const BKJPaginationButton = styled.button `
  box-sizing: border-box;
  width: 40px;
  height: 100%;
  background-color: ${({ theme, disabled }) => (disabled ? theme.colors.Grey3 : 'white')};
  border: 0.5px solid ${({ theme }) => theme.colors.Grey4};
  ${({ disabled }) => !disabled &&
    css `
      &:hover {
        background-color: ${({ theme }) => theme.colors.Grey1};
      }
      &:active {
        background-color: ${({ theme }) => theme.colors.Grey2};
      }
    `};
  &:first-child {
    border-radius: 8px 0px 0px 8px;
  }
  &:last-child {
    border-radius: 0px 8px 8px 0px;
  }
`;
export const BKJPaginationDisplay = styled.div `
  width: 100px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.Grey1};
  border: 0.5px solid ${({ theme }) => theme.colors.Grey4};
`;
export const BKJPaginationText = styled.p `
  ${({ theme }) => theme.fonts.PoppinsText};
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
`;
//# sourceMappingURL=BKJPagination.styled.js.map